{% block klarna_switch_field %}
    <mt-switch
        v-if="useMeteorComponent"
        v-bind="$attrs"
        :model-value="checkedValue"
        @update:model-value="onChangeHandler"
        bordered
    >
        <slot></slot>
    </mt-switch>

    <sw-switch-field-deprecated
        v-else
        v-bind="$attrs"
        :bordered="true"
        :value="value"
        @update:value="onChangeHandler"
    >
        <slot></slot>
    </sw-switch-field-deprecated>

    {% block klarna_disable_address_validation_confirm_modal %}
        <sw-confirm-modal
            v-if="showDisableAddressValidationModal"
            class="klarna-disable-address-validation-modal"
            :title="$tc('klarna-payment-configuration.settingsForm.apiConfiguration.modal-address.title')"
            :text="$tc('klarna-payment-configuration.settingsForm.apiConfiguration.modal-address.text')"
            @confirm="onConfirmDisableAddressValidation"
            @close="onCloseDisableAddressValidationModal"
            @cancel="onCloseDisableAddressValidationModal"
        />
    {% endblock %}
{% endblock %}